import { useLang } from '@/i18n';
import { useState } from 'react';
import PartnerModal from '../PartnerModal';
import EarlyBird from '../EarlyBird';
import styles from './index.module.scss';
import gtm from '@/utils/gtm';
import EcoImg from 'eco-design-components/base/eco-img';
import EcoButton from 'eco-design-components/base/eco-button';

export default function Comp() {
    const { t } = useLang('theProduct.BannerC');
    const [modalVisible, setModalVisible] = useState(false);

    const handleClick = () => {
        setModalVisible(true);
        gtm.push({
            __btn_id1: 'BannerC .link',
            __btn_id2: t(`btn`),
            __btn_type: 'common',
        });
    };

    return (
        <div className={`${styles.comp} BannerC GtmModuleData-section`} id="BannerC" data-section-id={styles.comp} data-section-title={t('title')}>
            <EcoImg
                pc="https://websiteoss.ecoflow.com/upload/image/1760583858947/BannerC-pc.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1760583858827/BannerC-h5.jpg"
                className="banner"
            />
            <div className="text-container">
                <p className="desc">{t('label')}</p>
                <h1>{t('title')}</h1>
                <div className="desc">{t(`desc`)}</div>
                <EarlyBird endTime={new Date('2026/1/1 15:59:59 GMT+8').getTime()} />
                <EcoButton onClick={handleClick} className="link GtmModuleData-btn-common" lRadius="ellipse" lSize="large">
                    {t(`btn`)}
                </EcoButton>
            </div>
            <PartnerModal visible={modalVisible} onClose={() => setModalVisible(false)} />
        </div>
    );
}
